/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { PutCall } from './PutCall';
import {
    PutCallFromJSON,
    PutCallFromJSONTyped,
    PutCallToJSON,
} from './PutCall';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * Represents one asset in our system (currently bond/futures/options/equity).
 * Only used to query, so no need for separate models with optional/mandatory s_id fields.
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    coId?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    description?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof Asset
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof Asset
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof Asset
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    primaryExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    cusip?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    maturityDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    sedol?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    mic?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    gicsCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    gicsSector?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    gicsIndustry?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    coupon?: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    issueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    ndvrChainId?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    firstNoticeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    exchangeProductCode?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    minTick?: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    settlementMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    market?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    priceMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    underlyingSymbol?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    strikePrice?: number;
    /**
     * 
     * @type {PutCall}
     * @memberof Asset
     */
    putCall?: PutCall;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    nSecurityJoinId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Asset
     */
    isActive?: boolean;
}



/**
 * Check if a given object implements the Asset interface.
 */
export function instanceOfAsset(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;

    return isInstance;
}

export function AssetFromJSON(json: any): Asset {
    return AssetFromJSONTyped(json, false);
}

export function AssetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Asset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'primaryExchange': !exists(json, 'primary_exchange') ? undefined : json['primary_exchange'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'maturityDate': !exists(json, 'maturity_date') ? undefined : json['maturity_date'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : json['expiration_date'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'sedol': !exists(json, 'sedol') ? undefined : json['sedol'],
        'mic': !exists(json, 'mic') ? undefined : json['mic'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'gicsCode': !exists(json, 'gics_code') ? undefined : json['gics_code'],
        'gicsSector': !exists(json, 'gics_sector') ? undefined : json['gics_sector'],
        'gicsIndustry': !exists(json, 'gics_industry') ? undefined : json['gics_industry'],
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
        'issueDate': !exists(json, 'issue_date') ? undefined : json['issue_date'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'ndvrChainId': !exists(json, 'ndvr_chain_id') ? undefined : json['ndvr_chain_id'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'firstNoticeDate': !exists(json, 'first_notice_date') ? undefined : json['first_notice_date'],
        'exchangeProductCode': !exists(json, 'exchange_product_code') ? undefined : json['exchange_product_code'],
        'minTick': !exists(json, 'min_tick') ? undefined : json['min_tick'],
        'settlementMethod': !exists(json, 'settlement_method') ? undefined : json['settlement_method'],
        'market': !exists(json, 'market') ? undefined : json['market'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
        'underlyingSymbol': !exists(json, 'underlying_symbol') ? undefined : json['underlying_symbol'],
        'strikePrice': !exists(json, 'strike_price') ? undefined : json['strike_price'],
        'putCall': !exists(json, 'put_call') ? undefined : PutCallFromJSON(json['put_call']),
        'nSecurityJoinId': !exists(json, 'n_security_join_id') ? undefined : json['n_security_join_id'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
    };
}

export function AssetToJSON(value?: Asset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'sc_id': value.scId,
        'co_id': value.coId,
        'symbol': value.symbol,
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'primary_exchange': value.primaryExchange,
        'cusip': value.cusip,
        'maturity_date': value.maturityDate,
        'expiration_date': value.expirationDate,
        'isin': value.isin,
        'sedol': value.sedol,
        'mic': value.mic,
        'country': value.country,
        'gics_code': value.gicsCode,
        'gics_sector': value.gicsSector,
        'gics_industry': value.gicsIndustry,
        'issuer': value.issuer,
        'coupon': value.coupon,
        'issue_date': value.issueDate,
        'length': value.length,
        'ndvr_chain_id': value.ndvrChainId,
        'contract_multiplier': value.contractMultiplier,
        'first_notice_date': value.firstNoticeDate,
        'exchange_product_code': value.exchangeProductCode,
        'min_tick': value.minTick,
        'settlement_method': value.settlementMethod,
        'market': value.market,
        'price_multiplier': value.priceMultiplier,
        'underlying_symbol': value.underlyingSymbol,
        'strike_price': value.strikePrice,
        'put_call': PutCallToJSON(value.putCall),
        'n_security_join_id': value.nSecurityJoinId,
        'is_active': value.isActive,
    };
}

